import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import Button from '../../UI/Button';
import Modal from '../../UI/Modal';
import RadioButtons from '../../UI/RadiouButtons';
import { RootState } from '../../store';
import AdvantagesSticker from '../../UI/AdvantagesSticker';
import { bookingStatusTextVerified } from '../../utils/bookingStatusUtils';
import { formatedBookingDay } from '../../utils/calendarDayUtils';
import { formattedDate } from '../../utils/date';
import MessageData from '../../API/MessageData';
import Validate from '../../API/Validate';
import PrivateData from '../../API/PrivateData';
import AppInput from '../../UI/AppInput';
import { TEXT } from '../../app_constants';

import bemClassName from '../../utils/bem';
import { IDealPanel } from './interface';

import './index.scss';

const bookingPanel = bemClassName('booking-panel');
const apartamentPayment = bemClassName('apartament-payment');
const payment = bemClassName('payment');

const DealPanel: React.FC<IDealPanel> = ({
  id,
  DealId,
  reservBeginDate,
  reservEndDate,
  stageId,
  contactless,
  dealTotal,
  dealFullpay,
  dealAllpay,
  dealRisk,
  dealPrepay,
  dealSurcharge,
  dealDiscount,
  dealBonus,
  dealCashback,
  dealTimeout,
  dealManager,
  deposit,
  statusBooking,
  setStatusBooking,
  anotherDeal,
  setAnotherDeal,
  dealWiFiLogin,
  dealWiFiPassword,
  dealCode,
}) => {
  const [openModalCancellation, setOpenModalCancellation] = useState<boolean>(false);
  const [disabledButtonCancellation, setDisabledButtonCancellation] = useState<boolean>(false);
  const [causeCancellation, setCauseCancellation] = useState<string>();
  const [bonusCard, setBonusCard] = useState<string | undefined>(undefined);
  const [bonusCardIsValid, setBonusCardIsValid] = useState<boolean>();

  const navigate = useNavigate();

  const isPaswordVerified = useSelector(
    (state: RootState) => state.autorizationStatus.isPaswordVerified,
  );
  const bonus = useSelector((state: RootState) => state.autorizationStatus.bonus);

  const handleIdentity = () => {
    navigate('/account#proof-of-identity');
  };

  const addingOrForwardingChat = () => {
    if (id) {
      MessageData.getCreatedСhat(id).then((item) => {
        if (item && item.chat_id) {
          window.location.href = `/account#messages_${item.chat_id}`;
        }
      });
    }
  };

  const deletUserBookingDeals = () => {
    if (DealId && causeCancellation) {
      setDisabledButtonCancellation(false);
      PrivateData.deleteUserDeals(DealId, Number(causeCancellation)).then(() => {
        setDisabledButtonCancellation(true);
        setOpenModalCancellation(false);
        setStatusBooking(false);
      });
    }
  };

  const handleCloseModalCancellation = () => {
    setOpenModalCancellation(false);
  };

  const handleSetBonus = (value: string) => {
    setBonusCard(value);
  };

  const handleCauseCancellationValue = (value: string) => {
    if (value) {
      setDisabledButtonCancellation(true);
    }
    setCauseCancellation(value);
  };

  const handleAnotherDeal = () => {
    setAnotherDeal(true);
    setDisabledButtonCancellation(true);
    setOpenModalCancellation(false);
  };

  useEffect(() => {
    if (dealCashback) {
      PrivateData.getPrivateUser().then((item) => {
        if (item.card) {
          setBonusCard(item.card.formatted);
          setBonusCardIsValid(item.card.valid);
        }
      });
    }
  }, [dealCashback]);

  useEffect(() => {
    const abortControllerBonusCard = new AbortController();
    if (bonusCard) {
      (async () => {
        try {
          const responseData = await Validate.checkBonusCard(
            bonusCard,
            abortControllerBonusCard.signal,
          );
          setBonusCardIsValid(true);
          if (responseData.formatted) {
            setBonusCard(responseData.formatted);
            PrivateData.getPrivateEditUserDate({ card: bonusCard });
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          } else {
            setBonusCardIsValid(false);
          }
        }
      })();
    }
    return () => {
      abortControllerBonusCard.abort();
    };
  }, [bonusCard, bonusCardIsValid]);

  const executePayment = async (
    amount: number | undefined,
    type: 'deposit' | 'fullpay' | 'prepay',
    useBonus = false,
  ) => {
    if (!DealId || !amount) {
      console.warn(`Отмена отправки: отсутствуют DealId или сумма`);
      return;
    }

    const validAmount: number = amount;

    const processRedirect = (item: any) => {
      const targetUrl = useBonus ? item?.return_url : item?.redirect_url;

      if (targetUrl) {
        window.location.href = targetUrl;
      }
    };

    try {
      const item = await PrivateData.addPayment(DealId, validAmount, type, dealCashback, useBonus);
      processRedirect(item);
    } catch (error: any) {
      try {
        const retryItem = await PrivateData.addPayment(
          DealId,
          validAmount,
          type,
          dealCashback,
          useBonus,
        );
        processRedirect(retryItem);
      } catch (retryError) {
        console.error('[Payment] ❌ Критическая ошибка:', retryError);
      }
    }
  };

  const handleAddDeposit = () => {
    executePayment(deposit, 'deposit');
  };

  const handleAddFullpay = () => {
    executePayment(dealFullpay, 'fullpay');
  };

  const handleAddPrepay = () => {
    executePayment(dealPrepay, 'prepay');
  };

  const handleAddBonuspay = () => {
    if (bonus) {
      executePayment(dealFullpay, 'fullpay', true);
    }
  };

  return (
    <>
      {statusBooking && !anotherDeal && (
        <>
          {statusBooking && stageId && (
            <h4
              className={bookingPanel('header-contacted-status', {
                status: stageId === '13' || stageId === '14' || stageId === '16',
              })}>
              {bookingStatusTextVerified(stageId)}
            </h4>
          )}
          {isPaswordVerified && contactless && dealAllpay && (
            <AdvantagesSticker data={['Бесконтактное заселение']} />
          )}
          {isPaswordVerified && (!dealAllpay || !contactless) && (
            <AdvantagesSticker data={['Обычное заселение']} />
          )}
          {statusBooking && stageId === 'PREPAYMENT_INVOICE' && dealRisk && (
            <div className={payment('alert-banner')}>
              <span className={payment('alert-banner-text')}>
                Квартира пока не закреплена за Вами. Она достанется гостю, который первым внесёт
                залог.
              </span>
            </div>
          )}
          {statusBooking && stageId === 'PREPAYMENT_INVOICE' && !dealRisk && dealAllpay && (
            <div className={payment('alert-banner')}>
              <span className={payment('alert-banner-text')}>
                Квартира пока не закреплена за Вами. Она достанется гостю, который первым внесёт
                оплату.
              </span>
            </div>
          )}
          {statusBooking && stageId === 'PREPAYMENT_INVOICE' && !dealRisk && !dealAllpay && (
            <div className={payment('alert-banner')}>
              <span className={payment('alert-banner-text')}>
                Квартира временно закреплена за Вами. В ближайшее время с вами свяжется персональный
                менеджер.
              </span>
            </div>
          )}
          <div className={payment('info-table')}>
            {contactless &&
              isPaswordVerified &&
              (stageId === '14' || stageId === '16') &&
              dealCode && (
                <div className={payment('info-table-row')}>
                  <span className={payment('info-table-label')}>Код замка</span>
                  <span className={payment('info-table-tag')}>{dealCode}</span>
                </div>
              )}
            {statusBooking && reservBeginDate && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Заезд</span>
                <span className={payment('info-table-value')}>
                  с {formatedBookingDay(reservBeginDate)}
                </span>
              </div>
            )}
            {statusBooking && reservEndDate && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Выезд</span>
                <span className={payment('info-table-value')}>
                  до {formatedBookingDay(reservEndDate)}
                </span>
              </div>
            )}
            {statusBooking && stageId === 'PREPAYMENT_INVOICE' && deposit && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Залог</span>
                <span className={payment('info-table-value')}>{deposit} ₽</span>
              </div>
            )}
            {statusBooking && dealSurcharge != null && Number(dealSurcharge) > 0 && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Остаток оплаты</span>
                <span className={payment('info-table-value')}>{dealSurcharge} ₽</span>
              </div>
            )}
            {!dealCashback && dealDiscount != null && dealDiscount > 0 && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Скидка</span>
                <span className={payment('info-table-value')}>{dealDiscount} ₽</span>
              </div>
            )}
            {dealCashback && dealDiscount != null && dealDiscount > 0 && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Кешбек</span>
                <span className={payment('info-table-value')}>{dealDiscount} ₽</span>
              </div>
            )}
            {statusBooking && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Общая стоимость</span>
                <span className={payment('info-table-value')}>{dealTotal} ₽</span>
              </div>
            )}
            {dealBonus && Number(dealBonus) > 0 && (
              <div className={payment('info-table-row')}>
                <span className={payment('info-table-label')}>Бонусы за бронь</span>
                <span className={payment('info-table-value')}>{dealBonus}</span>
              </div>
            )}
            {contactless &&
              (stageId === '14' || stageId === '16') &&
              dealWiFiLogin &&
              dealWiFiPassword && (
                <>
                  <div className={payment('info-table-row')}>
                    <span className={payment('info-table-label')}>Сеть Wi-Fi</span>
                    <span className={payment('info-table-value')}>{dealWiFiLogin}</span>
                  </div>
                  <div className={payment('info-table-row')}>
                    <span className={payment('info-table-label')}>Пароль Wi-Fi</span>
                    <span className={payment('info-table-value')}>{dealWiFiPassword}</span>
                  </div>
                </>
              )}
            {statusBooking && (stageId === '14' || stageId === '16') && deposit && (
              <>
                <div className={payment('info-table-row')}>
                  <span className={payment('info-table-label')}>Залог</span>
                  <span className={payment('info-table-value')}>{deposit} ₽</span>
                </div>
                <div className={payment('feature-card-description')}>
                  Возврат на карту оплаты в течение 1-2 банковских дней после выезда.
                </div>
              </>
            )}
          </div>
          <div className={bookingPanel('reservation-button-group')}>
            {statusBooking &&
              stageId === 'PREPAYMENT_INVOICE' &&
              deposit &&
              dealTimeout &&
              dealRisk && (
                <Button
                  externalClassName={bookingPanel('payment', {
                    payment_reservation: true,
                  })}
                  handleExternal={handleAddDeposit}
                  text="Внести залог"
                />
              )}
            {statusBooking && stageId === '13' && Number(dealFullpay) > 0 && !dealAllpay && (
              <Button
                externalClassName={bookingPanel('payment', {
                  payment_reservation: true,
                })}
                handleExternal={handleAddPrepay}
                text="Внести аванс"
              />
            )}
            {statusBooking && stageId === '13' && Number(dealFullpay) > 0 && dealAllpay && (
              <Button
                externalClassName={bookingPanel('payment', {
                  payment_reservation: true,
                })}
                handleExternal={handleAddFullpay}
                text="Оплатить проживание"
              />
            )}
            {statusBooking && stageId === '13' && Number(dealTotal) - Number(dealFullpay) > 0 && (
              <Button
                externalClassName={bookingPanel('payment', {
                  payment_reservation: true,
                })}
                handleExternal={handleAddFullpay}
                text="Оплатить остаток"
              />
            )}
            {dealTimeout && stageId === 'PREPAYMENT_INVOICE' && (
              <div className={payment('button-hint')}>
                Заявка действительна до {formattedDate(dealTimeout)}
              </div>
            )}
            {Number(dealPrepay) > 0 && stageId === '13' && !dealAllpay && (
              <div className={payment('button-hint')}>Необходима предоплата: {dealPrepay} ₽</div>
            )}
            {Number(dealFullpay) > 0 && stageId === '13' && dealAllpay && (
              <div className={payment('button-hint')}>Неоходимо оплатить: {dealFullpay} ₽</div>
            )}
            {stageId === '16' && Number(dealFullpay) > 0 && bonus >= Number(dealFullpay) && (
              <>
                <div className={payment('panel')}>
                  <h3 className={payment('deposit-header')}>
                    У Вас есть бонусные баллы: {bonus} ₽
                  </h3>
                  <div className={payment('button-purchase')}>
                    <Button
                      externalClassName={payment('button')}
                      text="Оплатить бонусными баллами"
                      handleExternal={handleAddBonuspay}
                    />
                  </div>
                </div>
              </>
            )}
            {dealCashback && (stageId === '14' || stageId === '16') && (
              <div className={payment('panel-cashback')}>
                <h3 className={payment('pay-header')}>
                  Кэшбек: <span className={payment('discount')}> {dealDiscount} ₽</span>
                </h3>
                <AppInput
                  inputId="cashbackCard"
                  text="Номер карты для получения кэшбека"
                  type={TEXT}
                  externalClassName={payment('field')}
                  handleExternal={handleSetBonus}
                  validate="Неправильный номер карты"
                  valueExternal={bonusCard}
                  isValidExternal={bonusCardIsValid}
                />
              </div>
            )}
            {dealManager && (
              <p className={apartamentPayment('number')}>
                Телефон менеджера: <span>{dealManager.phone}</span> ({dealManager.name})
              </p>
            )}
            {contactless && !isPaswordVerified && (
              <>
                <div className={payment('feature-card')}>
                  <div className={payment('feature-card-title')}>Бесконтактное заселение</div>
                  <div className={payment('feature-card-description')}>
                    Загрузите фото паспорта - после его проверки Вам будет доступно бесконтактное
                    заселение.
                  </div>
                </div>
                <Button
                  text="Загрузить документ"
                  handleExternal={handleIdentity}
                  externalClassName={bookingPanel('message')}
                />
              </>
            )}
            {contactless &&
              isPaswordVerified &&
              (stageId === '14' || stageId === '16') &&
              !dealCode && (
                <>
                  <div className={payment('feature-card')}>
                    <div className={payment('feature-card-title')}>Бесконтактное заселение</div>
                    <div className={payment('feature-card-description')}>
                      Код от электронного замка или кейбокса будет доступен за час до заезда.
                    </div>
                  </div>
                </>
              )}
            {contactless &&
              isPaswordVerified &&
              (stageId === '14' || stageId === '16') &&
              dealCode && (
                <>
                  <div className={payment('feature-card')}>
                    <div className={payment('feature-card-title')}>Как попасть в подъезд?</div>
                    <div className={payment('feature-card-description')}>
                      На домофоне наберите <b>123</b>, дверь откроется автоматически через 10 сек.
                    </div>
                  </div>
                </>
              )}
            <div className={payment('feature-card')}>
              <Button
                handleExternal={() => addingOrForwardingChat()}
                externalClassName={bookingPanel('message')}
                text="Сообщения"
              />
              {statusBooking && stageId === 'PREPAYMENT_INVOICE' && (
                <div className={payment('cancel')}>
                  <Button
                    externalClassName={bookingPanel('cancel-button', {
                      cancle_reservation: true,
                    })}
                    text="Отменить бронирование"
                    handleExternal={() => setOpenModalCancellation(true)}
                    red
                  />
                </div>
              )}
            </div>
            <div>
              <Button
                handleExternal={() => handleAnotherDeal()}
                externalClassName={bookingPanel('button')}
                text="Забронировать на другие даты"
              />
            </div>
            <Modal open={openModalCancellation} handleClose={handleCloseModalCancellation}>
              <h3 className={bookingPanel('modal-header')}>Выберите причину отмены брони</h3>
              {id && reservBeginDate && reservEndDate && (
                <RadioButtons
                  data={[
                    { text: 'Изменились обстоятельства', value: 2 },
                    { text: 'Нашел дешевле', value: 6 },
                    { text: 'Отменилась командировка', value: 1 },
                    { text: 'Другое', value: 11 },
                  ]}
                  name={`causeCancellation_${id}_${reservBeginDate}_${reservEndDate}`}
                  externalClassName={bookingPanel('field')}
                  handleExternal={handleCauseCancellationValue}
                  valueExternal={causeCancellation}
                />
              )}
              <div className={bookingPanel('modal-button')}>
                <Button text="Закрыть" handleExternal={() => handleCloseModalCancellation()} red />
                <Button
                  text="Отменить бронирование"
                  handleExternal={() => deletUserBookingDeals()}
                  disable={!disabledButtonCancellation}
                  typeButton="submit"
                />
              </div>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default DealPanel;
